import {minimumVersion} from './config.js';
// 新协议
function kkmhhybrid_notify_danmustyle_ischanged (opt) {
  hybrid({
    hybridParam: {
        schema: "kkmhhybrid",
        tagname: "notify_danmustyle_ischanged",
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}

// 旧协议
function kkhybrid_notify_danmustyle_ischanged (opt) {
  hybrid({
    hybridParam: {
        schema: "kkhybrid",
        tagname: "notify_danmustyle_ischanged",
    },
    callback: function (res) {
      opt.callback && opt.callback(res);
    }
  });
}


/**
 * 通知已更改弹幕气泡<br>
 * kkmhhybrid://notify_danmustyle_ischanged,wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=285411253}<br>
 * kkhybrid://notify_danmustyle_ischanged,wiki地址：{@link https://wiki.quickcan.com/pages/viewpage.action?pageId=38832119}<br>
 * @param {Object} opt 参数对象
 * @param {Function} opt.callback 回调函数
 * @param {Number} criticalAppVersion 新旧协议兼容的判断版本（默认值在hybrid/index.js里配置），客户端版本小于该值使用旧协议，其余使用新协议
 */
function notify_danmustyle_ischanged (opt, criticalAppVersion) {
  var allow = window.kkBaseInfo.allowToKkmhhybrid(criticalAppVersion, minimumVersion);
  if(allow) {
    // 调用新协议
    kkmhhybrid_notify_danmustyle_ischanged(opt);
  } else {
    // 调用旧协议
    kkhybrid_notify_danmustyle_ischanged(opt);
  }
}

export default notify_danmustyle_ischanged;




// WEBPACK FOOTER //
// ./node_modules/@kk/h5-sdk/src/notify_danmustyle_ischanged/index.js